import { render } from "./moduleWorkflow.vue?vue&type=template&id=43497c54&scoped=true"
import script from "./moduleWorkflow.vue?vue&type=script&lang=js"
export * from "./moduleWorkflow.vue?vue&type=script&lang=js"

import "./moduleWorkflow.vue?vue&type=style&index=0&id=43497c54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43497c54"]])

export default __exports__